import { Box } from '@factorialco/deprecated-design-system'

import { useIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'

import { BlockingIssues } from './BlockingIssues'
import { IntegrationSettingsLink } from './IntegrationSettingsLink'
import { LastSync } from './LastSync'

export const SyncFooter = () => {
  const { syncEnabled } = useIntegrationsSyncContext()

  if (!syncEnabled) return null

  return (
    <Box
      paddingTop="s8"
      paddingBottom="s2"
      paddingX="s24"
      background="darker040"
      style={{
        position: 'relative',
        left: '-24px',
        marginTop: '-17px',
        zIndex: '10',
        borderBottomLeftRadius: '14px',
        borderBottomRightRadius: '14px',
        alignItems: 'flexStart',
        flexDirection: 'row',
        gap: '8px',
      }}
    >
      <LastSync />
      <BlockingIssues />
      <IntegrationSettingsLink />
    </Box>
  )
}
